import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Policies } from '@/features/policies'
import { requireActiveSubscription } from '@/lib/middleware'

const searchSchema = z.object({
  policy: z.string().optional(),
  // Task 10 (phase 2) — widened from ['overview','acknowledgements'] to the
  // full six-tab set: `?policy=` deep links now redirect straight to
  // `/compliance/policies/$policyId?tab=...` (policies_.$policyId.tsx),
  // whose own validateSearch carries the same six-value enum.
  tab: z.enum(['overview', 'grade', 'versions', 'acknowledgements', 'standards', 'activity']).optional(),
  filter: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
  // Ruling 14d: `?new=1&standard=<code>` opens the create dialog pre-selecting
  // the standard mapping (the Standards page's "Start: policy from template"
  // action for a not_started standard).
  new: z.string().optional(),
  standard: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/policies')({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: searchSchema,
  component: Policies,
})
